// Main Lib
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import {default as Vuedals, Component as Vuedal} from 'vuedals'
import VueSimpleSVG from 'vue-simple-svg'
import SocialSharing from 'vue-social-sharing';

import PageLogin from './component/page-login/PageUserLoginComponent.vue'
import PageSearch from './component/page-search/PageSearchComponent.vue'
import PageMaintenance from './component/page-maintenance/PageMaintenance.vue'

import MenuTop from './component/menu-top/MenuTop.vue'

import MenuGeneric from './component/menu/MenuGeneric.vue'
import MenuLocal from './component/menu/MenuLocal.vue'
import MenuFooter from './component/menu-footer/MenuFooter.vue'
import MenuLegals from './component/menu-legals/MenuLegals.vue'

import BlockBackToTop from './component/block-back-to-top/BlockBackToTop.vue'
import BlockBreadcrumb from './component/block-breadcrumb/BlockBreadcrumb.vue'
import BlockMoreInfos from './component/block-more-infos/BlockMoreInfos.vue'
import BlockSearch from './component/block-search/BlockSearch.vue'
import BlockSticky from './component/block-sticky/BlockSticky.vue'
import BlockPlezi from './component/block-js-plezi/BlockPlezi.vue'
import BlockWebformNewsletter from './component/block-webform-newsletter/BlockWebformNewsletter.vue'

import RegionFooter from './component/region-footer/RegionFooter.vue'

import NodeHomepageSante from './component/node-homepage-sante/NodeHomepageSante.vue'
import NodeHomepageCorporate from './component/node-homepage-corporate/NodeHomepageCorporate.vue'
import NodeHomepage from './component/node-homepage/NodeHomepage.vue'
import NodeArticle from './component/node-article/NodeArticle.vue'
import NodeListeArticles from './component/node-liste-articles/NodeListeArticles.vue'
import NodeFloating from './component/node-floating/NodeFloating.vue'
import NodeContact from './component/node-contact/NodeContact.vue'
import NodeCustomerArea from './component/node-customer-area/NodeCustomerArea.vue'
import NodeAboutUs from './component/node-about-us/NodeAboutUs.vue'
import NodeGroupe from './component/node-groupe/NodeGroupe.vue'
import NodeExpertise from './component/node-expertise/NodeExpertise.vue'
import NodeNewsletter from './component/node-newsletter/NodeNewsletter.vue'
import NodePress from './component/node-press/NodePress.vue'
import NodeLegal from './component/node-legal/NodeLegal.vue'
import NodeConfirmationContact from './component/node-confirmation-contact/NodeConfirmationContact.vue'
import NodeError from './component/node-error/NodeError.vue'
import NodeAgency from './component/node-agency/NodeAgency.vue'

import ParagraphYoutube from './component/paragraph-youtube/ParagraphYoutube.vue'
import ParagraphLinks from './component/paragraph-links/ParagraphLinks.vue'
import ParagraphText from './component/paragraph-text/ParagraphText.vue'
import ParagraphColumns from './component/paragraph-columns/ParagraphColumns.vue'
import ParagraphHubspotForm from './component/paragraph-hubspot-form/ParagraphHubspotForm.vue'
import ParagraphCustomerArea from './component/paragraph-customer-area/ParagraphCustomerArea.vue'
import ParagraphLocation from './component/paragraph-location/ParagraphLocation.vue'
import ParagraphProducts from './component/paragraph-products/ParagraphProducts.vue'
import ParagraphLatestNews from './component/paragraph-latest-news/ParagraphLatestNews.vue'
import ParagraphCorporateHero from './component/paragraph-corporate-hero/ParagraphCorporateHero.vue'

import ParagraphProductTitle from './component/paragraph-product-title/ParagraphProductTitle.vue'
import ParagraphProductContent from './component/paragraph-product-content/ParagraphProductContent.vue'
import ParagraphProductContentVideo from './component/paragraph-product-content/video/ParagraphProductContentVideo.vue'
import ParagraphProductCards from './component/paragraph-product-cards/ParagraphProductCards.vue'
import ParagraphProductQuote from './component/paragraph-product-quote/ParagraphProductQuote.vue'
import ParagraphProductCardsExp from './component/paragraph-product-cards-exp/ParagraphProductCardsExp.vue'
import ParagraphProductLinks from './component/paragraph-product-links/ParagraphProductLinks.vue'
import ParagraphProductVideo from './component/paragraph-product-video/ParagraphProductVideo.vue'
import ParagraphProductKeyfacts from './component/paragraph-product-keyfacts/ParagraphProductKeyfacts.vue'
import ParagraphProductImage from './component/paragraph-product-image/ParagraphProductImage.vue'

import ParagraphKeyNumbers from './component/paragraph-key-numbers/ParagraphKeyNumbers.vue'
import ParagraphKeyNumberPicto from './component/paragraph-key-number-picto/ParagraphKeyNumberPicto.vue'

import ParagraphTextContent from './component/paragraph-text-content/ParagraphTextContent.vue'
import ParagraphBlocWysiwyg from './component/paragraph-bloc-wysiwyg/ParagraphBlocWysiwyg.vue'
import ParagraphBlockEmphasize from './component/paragraph-block-emphasize/ParagraphBlockEmphasize.vue'
import ParagraphBlockNewsImage from './component/paragraph-block-news-image/ParagraphBlockNewsImage.vue'
import ParagraphBlockNewsContact from './component/paragraph-block-news-contact/ParagraphBlockNewsContact.vue'
import ParagraphBlockCta from './component/paragraph-block-cta/ParagraphBlockCta.vue'

import ParagraphPersonaHero from './component/paragraph-persona-hero/ParagraphPersonaHero.vue'
import ParagraphPersonaLinks from './component/paragraph-persona-links/ParagraphPersonaLinks.vue'
import ParagraphPersonaContent from './component/paragraph-persona-content/ParagraphPersonaContent.vue'
import ParagraphPersonaInfo from './component/paragraph-persona-info/ParagraphPersonaInfo.vue'

import ParagraphSeemore from './component/paragraph-see-more/ParagraphSeemore.vue'

import ParagraphBlocAudit from './component/paragraph-bloc-audit/ParagraphBlocAudit.vue'

import FieldRelated from './component/field-related/FieldRelated.vue'
import NodeTeaser from './component/node-teaser/NodeTeaser.vue'

import Actus from './component/actus/Actus.vue'

import './common/app.sass'

import 'script-loader!./../node_modules/aos/dist/aos.js'
import 'script-loader!./../node_modules/waypoints/lib/noframework.waypoints.js'
import '../node_modules/aos/dist/aos.css'

Vue.use(ElementUI, { locale });
Vue.use(Vuedals);
Vue.use(VueSimpleSVG);

Vue.component('social-sharing', SocialSharing);

Vue.component('page-login', PageLogin);
Vue.component('page-search', PageSearch);
Vue.component('page-maintenance', PageMaintenance);

Vue.component('block-back-to-top', BlockBackToTop);
Vue.component('block-breadcrumb', BlockBreadcrumb);
Vue.component('block-more-infos', BlockMoreInfos);
Vue.component('block-search', BlockSearch);
Vue.component('block-sticky', BlockSticky);
Vue.component('block-plezi-js', BlockPlezi);
Vue.component('block-webform-newsletter', BlockWebformNewsletter);

Vue.component('menu-top', MenuTop);
Vue.component('menu-footer', MenuFooter);
Vue.component('menu-generic', MenuGeneric);
Vue.component('menu-local', MenuLocal);
Vue.component('menu-footer', MenuFooter);
Vue.component('menu-legals', MenuLegals);

Vue.component('region-footer', RegionFooter);

Vue.component('node-homepage-sante', NodeHomepageSante);
Vue.component('node-homepage-corporate', NodeHomepageCorporate);
Vue.component('node-homepage', NodeHomepage);
Vue.component('node-article', NodeArticle);
Vue.component('node-liste-article', NodeListeArticles);
Vue.component('node-floating', NodeFloating);
Vue.component('node-contact', NodeContact);
Vue.component('node-customer-area', NodeCustomerArea);
Vue.component('node-about-us', NodeAboutUs);
Vue.component('node-groupe', NodeGroupe);
Vue.component('node-expertise', NodeExpertise);
Vue.component('node-newsletter', NodeNewsletter);
Vue.component('node-press', NodePress);
Vue.component('node-agency', NodeAgency);
Vue.component('node-legal', NodeLegal);
Vue.component('node-confirmation-contact', NodeConfirmationContact);
Vue.component('node-error', NodeError);

Vue.component('paragraph-youtube', ParagraphYoutube);
Vue.component('paragraph-links', ParagraphLinks);
Vue.component('paragraph-text', ParagraphText);
Vue.component('paragraph-columns', ParagraphColumns);
Vue.component('paragraph-hubspot-form', ParagraphHubspotForm);
Vue.component('paragraph-customer-area', ParagraphCustomerArea);
Vue.component('paragraph-location', ParagraphLocation);
Vue.component('paragraph-products', ParagraphProducts);
Vue.component('paragraph-latest-news', ParagraphLatestNews);
Vue.component('paragraph-corporate-hero', ParagraphCorporateHero);

Vue.component('paragraph-product-title', ParagraphProductTitle);
Vue.component('paragraph-product-content', ParagraphProductContent);
Vue.component('paragraph-product-content-video', ParagraphProductContentVideo);
Vue.component('paragraph-product-cards', ParagraphProductCards);
Vue.component('paragraph-product-quote', ParagraphProductQuote);
Vue.component('paragraph-product-cards-exp', ParagraphProductCardsExp);
Vue.component('paragraph-product-links', ParagraphProductLinks);
Vue.component('paragraph-product-video', ParagraphProductVideo);
Vue.component('paragraph-product-keyfacts', ParagraphProductKeyfacts);
Vue.component('paragraph-product-image', ParagraphProductImage);

Vue.component('paragraph-key-numbers', ParagraphKeyNumbers);
Vue.component('paragraph-key-number-picto', ParagraphKeyNumberPicto);

Vue.component('paragraph-text-content', ParagraphTextContent);
Vue.component('paragraph-bloc-wysiwyg', ParagraphBlocWysiwyg);
Vue.component('paragraph-block-emphasize', ParagraphBlockEmphasize);
Vue.component('paragraph-block-news-image', ParagraphBlockNewsImage);
Vue.component('paragraph-block-news-contact', ParagraphBlockNewsContact);
Vue.component('paragraph-block-cta', ParagraphBlockCta);

Vue.component('paragraph-persona-hero', ParagraphPersonaHero);
Vue.component('paragraph-persona-links', ParagraphPersonaLinks);
Vue.component('paragraph-persona-content', ParagraphPersonaContent);
Vue.component('paragraph-persona-info', ParagraphPersonaInfo);

Vue.component('paragraph-seemore', ParagraphSeemore);
Vue.component('paragraph-bloc-audit', ParagraphBlocAudit);

Vue.component('node-teaser', NodeTeaser);
Vue.component('field-related', FieldRelated);

Vue.component('actus', Actus);

Vue.component("vuedal", Vuedal);

import $ from 'jquery';
import { detect } from 'detect-browser';

// Init
new Vue({
    el: '#app',
    mounted() {
        $(this.$el).removeClass("loading")
        const browser = detect();
        if (browser) {
            $("html").addClass("browser-" + browser.name);
        }

        // console.log(browser.name);
        if (browser.name === "ie") {
            [...document.querySelectorAll(".image-fit")].forEach(imageWrapper => {
                const imgSrc = imageWrapper.querySelector("img").src;
                if (imgSrc) {
                    imageWrapper.classList.add("background-fit");
                    imageWrapper.style.backgroundImage = `url(${imgSrc})`;
                }
            });
        }

        // Create a cookie
        function setCookie(cname, cvalue, exdays) {
          const d = new Date();
          d.setTime(d.getTime() + (exdays*24*60*60*1000));
          let expires = "expires="+ d.toUTCString();
          document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        // Get a cookie
        function getCookie(cname) {
          let name = cname + "=";
          let decodedCookie = decodeURIComponent(document.cookie);
          let ca = decodedCookie.split(';');
          for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        }

        // NEWSLETTER - POPIN PLEZI
        if ($('.js-pp-btn').length) {
          // Disable submit btn
          $(".js-pp-container form").find("[type='submit']").prop("disabled", true);

          // Create elements to display errors messages
          $( "<div class='email-error js-pp-error'></div>" ).insertAfter($('.js-pp-container [type="email"]'));
          $( "<div class='checkboxes-error js-pp-error'></div>" ).insertAfter($('.js-pp-container [type="checkbox"]').last().parent());

          // Open/close the popin with the newsletter btn
          $('.js-pp-btn').on('click', function() {
            $(this).toggleClass('opened');
            $(this).parent().find('.js-pp-container').toggleClass('opened');
          })

          // Open the popin after scrolling the page if there is no cookie to indicate that
          // -> the user have already subscribe in the last month
          // -> the popin was displayed in the last 7 days
          if (!getCookie('custom-plezi-cookie')) {
            $(window).on('scroll',function() {
              if ($(document).scrollTop() > 2000) {
                $('.js-pp-btn').addClass('opened');
                $('.js-pp-container').addClass('opened');
                $(window).off('scroll');

                // Create a cookie which expired in 7 days
                setCookie("custom-plezi-cookie", "true", 7);
              }
            });
          }

          // Check the email format
          function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
          };

          // Check if there are no more errors
          function checkErrors() {
            if ($('.js-pp-error').length) {
              $(".js-pp-container form").find("[type='submit']").prop("disabled", true);
            } else {
              $(".js-pp-container form").find("[type='submit']").removeAttr("disabled");
            }
          };

          // Check the checkboxes
          $('.js-pp-container [type=checkbox]').on('change', function() {
            if (this.checked) {
              $('.checkboxes-error').removeClass('js-pp-error').html("");
            } else {
              if (!$('.js-pp-container [type="checkbox"]:checked').length) {
                $('.checkboxes-error').addClass('js-pp-error').html("Veuillez sélectionner le(s) sujet(s) que vous souhaitez recevoir dans votre newsletter");
              }
            }

            checkErrors();
          });

          // Typing on email field
          $('.js-pp-container [type="email"]').on('keyup', function(){
            if (this.value.length == 0) {
              $('.email-error').addClass('js-pp-error').html("Veuillez sélectionner le(s) sujet(s) que vous souhaitez recevoir dans votre newsletter").parent().addClass('error');
            } else if (this.value.length < 6) {
                $('.email-error').addClass('js-pp-error').html("Veuillez saisir votre e-mail au format exemple@domaine.com").parent().addClass('error');
            } else if (!validateEmail(this.value)) {
                $('.email-error').addClass('js-pp-error').html("Veuillez saisir votre e-mail au format exemple@domaine.com").parent().addClass('error');
            } else {
              $('.email-error').removeClass('js-pp-error').html('').parent().removeClass('error');
            }

            checkErrors();
          })


          // Observer to close the confirmation message
          const observer = new MutationObserver(function(mutations_list) {
            mutations_list.forEach(function(mutation) {
              mutation.addedNodes.forEach(function(added_node) {
                if(added_node.tagName == 'FORM' && $(added_node).find('.webform-confirmation').length) {
                  if ($(window).width() >= 900) {
                    setTimeout(() => {
                      $('.js-pp-btn').trigger('click');
                    }, 1000);
                  }
                  observer.disconnect();

                  // Create a cookie which expired in 30 days
                  setCookie("custom-plezi-cookie", "true", 30);
                }
              });
            });
          });

          observer.observe(document.querySelector(".js-pp-container .webform-ajax-form-wrapper"), { subtree: false, childList: true });
        }

        // Remove the style attribute which hide the video
        if ($('.video-container.youtube_player').attr('style')) {
          $('.video-container.youtube_player').removeAttr('style');
        }

    }
});
